import React, {Component} from 'react'
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';

import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';  


class WebRouter extends Component {
    render() {
        return (
            <ThemeProvider theme={theme}>
                <Router>
                    <Routes>
                        <Route exact path='/' element={<Login />}/>
                        <Route path="/dashboard" element={<Dashboard/>}/>
                    </Routes>
                </Router>
            </ThemeProvider>
            
        )
    }
}

export default WebRouter